module.exports = __webpack_public_path__ + "d2cd75d25c53c90b9e6a8cc6e2ae13b2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-4.png
// module id = 2680
// module chunks = 0